import { StyleDeclarationValue } from 'aphrodite';
import { CoffeeAppLayout } from '../components/CoffeeAppLayout';
import { MainContainer } from '../containers/MainContainer';
import { CoffeeAppChrome } from './CoffeeAppChrome';
import { CoffeeSubBar } from './CoffeeSubBar';
import { useCoffeeShellV2 } from './useCoffeeShellV2';

/**
 * The flag is read here and nowhere else, so the element type at this position never varies by route.
 * A per-route choice would change the type on every boundary crossing, tearing down and rebuilding the
 * provider subtree that `Switch` otherwise preserves.
 */
export const CoffeeShell = ({
	children,
	bodyContainerStyles,
}: {
	children?: React.ReactNode;
	bodyContainerStyles?: StyleDeclarationValue[];
}) => {
	const [shellV2] = useCoffeeShellV2();
	return (
		<>
			{/*
			 * Scoped to the legacy routes, not hoisted above the `Switch`: `/login` has no account yet
			 * (the no-Coffee banner would fire), and the bare routes own their own search panel and call
			 * pipeline, which a second Cmd+K binding and incoming-call modal would fight.
			 */}
			<CoffeeAppChrome />
			{shellV2 ? (
				<CoffeeAppLayout subBar={<CoffeeSubBar />} pageRootStyles={bodyContainerStyles}>
					{children}
				</CoffeeAppLayout>
			) : (
				<MainContainer bodyContainerStyles={bodyContainerStyles}>{children}</MainContainer>
			)}
		</>
	);
};
